<template>
  <div>
    <div v-if="conmmentList.length==0" style="text-align:center;margin-bottom:20px;margin-top:20px" >
        <img src="../../assets/暂无内容.jpg" alt="" style="width:200px">
    </div>
    <div class="flex right_sortbox">
      <p
        :class="sortboxIndex == index ? 'p_active' : ''"
        v-for="(items, index) in sortBox"
        :key="index"
        @click="getSortBox(index)"
      >
        {{ items.name }} ({{ items.num }})
      </p>
    </div>
    <!--<div class="flex right_sortbox2">-->
      <!--<p v-for="(items, index) in sortBox[sortboxIndex].content" :key="index">-->
        <!--{{ items.name }} ({{ items.num }})-->
      <!--</p>-->
    <!--</div>-->
    <div v-for="(items, index) in conmmentList"
         :key="index">
      <div class="comList flex">
      <div class="comList_img">
        <img :src="items.image" alt="" />
      </div>
      <div class="comList_con">
        <p class="con_title">{{items.title}}</p>
        <p class="con_mess">
          {{items.messages}}
        </p>
        <span> {{items.time}}</span>
      </div>
      <div class="comList_star">
        <div class="comList_star_A flex">
          <span>描述相符</span>
          <el-rate v-model="items.designerStar" disabled :colors="colors"> </el-rate>
        </div>
        <div class="comList_star_A flex">
          <span>服务态度</span>
          <el-rate v-model="items.designerStar2" disabled :colors="colors"> </el-rate>
        </div>
        <div class="comList_star_A flex">
          <span>专业程度</span>
          <el-rate v-model="items.designerStar3" disabled :colors="colors"> </el-rate>
        </div>
      </div>
    </div>
      <!-- 回复 -->
      <div v-if="items.reply" class="additional_evaluation">
        设计师回复：{{items.reply}}
      </div>
    </div>
    <div style="text-align: right; padding: 0 0px 30px">
      <el-pagination
              background
              @current-change="handleCurrentChange"
              @prev-click="handleCurrentChange"
              @next-click="handleCurrentChange"
              layout="total,prev, pager, next,jumper"
              :current-page="current"
              :page-size="pageSize"
              :total="total" class="pagination">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  import { getEvaluationList, getUserInfo, getTagsByGoodsId, } from "../../utils/interface";
  export default {
  //   评论
  name: "designComments",
  components: {},
  props: ['title'],
  data() {
    return {
      sortBox: [
      ],
      sortboxIndex: "0",
      colors: ["#da251d", "#da251d", "#da251d"],
      conmmentList:[
      ],
      current: 1,
      total: 0,
      pageSize: 5,
      form:{},
      uuid:'',
    };
  },
    created() {
      this.uuid = this.$route.params.uuid;
      this.commentList();
    },
  methods: {
    getSortBox(index) {
      this.sortboxIndex = index;
      this.handleCurrentChange(1);
    },
    // 分页
    handleCurrentChange(val) {
      this.current = val
	  window.scrollTo(0,0);
      this.commentList();
    },
    commentList() {
      if(this.sortBox.length > 1){
        this.form.tags = this.sortBox[this.sortboxIndex].id;
      }
      this.form.uuid = this.$props.title;
      console.log("userId", this.$props.title);
      this.form.orderType = 'DESIGN';
      this.form.evaluationType = 'NORMAL';
      this.form.current = this.current;
      this.form.pageSize = this.pageSize;
      getEvaluationList(this.form).then((res) => {
        console.log(res);
        if (res != null && res.list != null && res.list.length > 0) {
          this.total = res.total;
          this.conmmentList = [];
          if(this.sortBox.length == 0) {
            this.sortBox.push({
              name: '全部',
              num: res.total
            });
          }
          if(this.sortBox.length == 1){
            getTagsByGoodsId(this.form).then((res) => {
              if (res != null && res.length > 0) {
                res.forEach((items, index) => {
                  this.sortBox.push({
                    id: items.tagUuid,
                    name: items.tagName,
                    num: items.evaluationNum,
                  });
                });
              }
            });
          }
          res.list.forEach((item, index) => {
            let evaluation = {};
            evaluation.order = item;
            evaluation.uuid = item.uuid;
            evaluation.title = item.creator;
            evaluation.messages = item.evaluationContent;
            evaluation.designerStar = parseInt(item.descriptionPoint);
            evaluation.designerStar2 = parseInt(item.servicePoint);
            evaluation.designerStar3 = parseInt(item.transportPoint);
            evaluation.time = item.createTime
            evaluation.image = (item.iconUrl ? item.iconUrl : require('../../assets/设计市场/头像1.jpeg'));

            if(item.addedReplys != null && item.addedReplys.length > 0){
              item.addedReplys.some((item, index) => {
                if(item.evaluationType == 'REPLY'){
                  evaluation.reply = item.evaluationContent;
                  return true;
                }
              });
            }
            this.conmmentList.push(evaluation);
            console.log(this.conmmentList);
          });
        } else {
          this.total = 0;
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
.blue {
  color: #1181ff;
}
.right_sortbox {
  font-size: 14px;
  height: 32px;
  line-height: 32px;
  margin-bottom: 15px;
  margin-top: 20px;
  p {
    cursor: pointer;
    margin-right: 40px;
    padding: 0 10px;
  }
  .p_active {
    color: #1181ff;
    background: #f3f8ff;
    border-radius: 8px;
  }
}
.right_sortbox2 {
  font-size: 14px;
  height: 32px;
  line-height: 32px;
  margin-bottom: 15px;
  p {
    cursor: pointer;
    margin-right: 40px;
    padding: 0 10px;
    background: #f5f5f5;
    border-radius: 10px;
  }
}
.additional_evaluation {
  font-size: 14px;
  color: #AF874D;
  width: 80%;
  margin-bottom: 20px;
  line-height: 24px;
  background: #efefef7a;
  border-radius: 10px;
  padding: 20px;
}
.comList {
  border: 1px solid #efefef;
  border-radius: 10px;
  width: 100%;
  padding: 15px;
  box-sizing: border-box;
  -moz-box-sizing: border-box; /* Firefox */
  -webkit-box-sizing: border-box; /* Safari */
  margin-top: 15px;
  background: #fff;
  justify-content: space-between;
  align-items: center;
  .comList_img {
    width: 66px;
    height: 66px;
    background: #efefef;
    border-radius: 50%;
    margin-right: 15px;
    img {
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }
  }
  .comList_con {
    color: #777;
    margin-right: 10px;
    flex: 1;
    .con_title {
      font-size: 16px;
      margin-bottom: 5px;
    }
    .con_mess {
      font-size: 14px;
    }
    span {
      color: rgb(194, 194, 194);
      font-size: 12px;
    }
  }
  .comList_star {
    flex-shrink: 0;

    .comList_star_A {
      align-content: center;
      margin-bottom: 3px;
      span {
        color: rgb(194, 194, 194);
        font-size: 13px;
        margin-right: 5px;
        line-height: 22px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/design/designComments.vue